import { clsx } from 'clsx';
import { Link } from 'react-router';

import { ArrowIcon } from '@/components/icons/main-block';
import { HowItWorks } from '@/components/MainBlock/HowItWorks/HowItWorks.tsx';
import { Button } from '@/components/shared/Button';
import { LinkWithPrevLocation } from '@/components/shared/LinkWithPrevLocation/LinkWithPrevLocation.tsx';
import { appRoutes } from '@/routes/app-routes.ts';

import { MainBlockContainer } from './MainBlockContainer/MainBlockContainer.tsx';
import cn from './styles.module.scss';

export const MainBlock = () => {
    return (
        <section className={cn.mainBlock}>
            <MainBlockContainer className={clsx(cn.firstRow, cn.cashback)}>
                <div className={cn.imgWrapper}>
                    <img src="/images/main/phone0.svg" alt="" />
                </div>
                <div className={cn.cashbackContent}>
                    <div className={cn.cashbackLeft}>
                        <h2>Кэшбек на сотовую связь</h2>
                        <LinkWithPrevLocation
                            to={`/${appRoutes.profile}/${appRoutes.loyaltyProgram}`}
                        >
                            <Button className={clsx(cn.waysToEarnBtn, cn.hideOnMob)}>
                                <div className={cn.coinsIcon}>
                                    <img src="/images/icons/coins_gradient.svg" alt="" />
                                </div>
                                <span className={cn.btnText}>2 способа зарабатывать</span>
                                <span className={cn.arrowIcon}>{ArrowIcon}</span>
                            </Button>
                        </LinkWithPrevLocation>
                    </div>
                    <div className={cn.cashbackRight}>
                        <h5>
                            Предложи номера друзьям <br />
                            или пригласи их в Другоманию:
                        </h5>
                        <div className={cn.steps}>
                            <div className={cn.step}>
                                <div className={cn.stepNumber}>1</div>
                                <div className={cn.stepText}>
                                    Получай с каждого номера <br />
                                    100 бонусов ежемесячно (1 бонус = 1 руб.)
                                </div>
                            </div>
                            <div className={cn.step}>
                                <div className={cn.stepNumber}>2</div>
                                <div className={cn.stepText}>
                                    Приглашай друзей <br />
                                    для дополнительного дохода
                                </div>
                            </div>
                        </div>
                        <LinkWithPrevLocation
                            to={`/${appRoutes.profile}/${appRoutes.loyaltyProgram}`}
                        >
                            <Button className={clsx(cn.waysToEarnBtn, cn.hideOnDesk)}>
                                <div className={cn.coinsIcon}>
                                    <img src="/images/icons/coins_gradient.svg" alt="" />
                                </div>
                                <span className={cn.btnText}>2 способа зарабатывать</span>
                                <span className={cn.arrowIcon}>{ArrowIcon}</span>
                            </Button>
                        </LinkWithPrevLocation>
                    </div>
                </div>
            </MainBlockContainer>
            <MainBlockContainer className={clsx(cn.secondRow, cn.chooseNumBlock)}>
                <h3>Выбери номер</h3>
                <div className={cn.btnsContainer}>
                    <Link to={appRoutes.prettyNums} className={clsx(cn.btn, cn.bgBrand1)}>
                        <div className={cn.btnContent}>
                            <span className={cn.btnText}>Красивые номера</span>
                            <span className={cn.btnSubText}>
                                Уникальная последовательность цифр в номере
                            </span>
                        </div>
                        <span className={cn.btnArrow}>{ArrowIcon}</span>
                    </Link>
                    <Link to={appRoutes.goodTariffs} className={clsx(cn.btn, cn.bgBrand2)}>
                        <div className={cn.btnContent}>
                            <span className={cn.btnText}>Выгодные тарифы</span>
                            <span className={cn.btnSubText}>
                                Тарифы дешевле рынка с обычным номером
                            </span>
                        </div>

                        <span className={cn.btnArrow}>{ArrowIcon}</span>
                    </Link>
                </div>
            </MainBlockContainer>
            <MainBlockContainer className={clsx(cn.firstRow, cn.howItWorks)}>
                <h3>Как это работает</h3>
                <HowItWorks />
            </MainBlockContainer>
        </section>
    );
};
